export enum PhxDataTableSelectionMode {
    None = 'none',
    Single = 'single',
    Multiple = 'multiple'
}
